import { Dialog } from '@platform/design-system';
import styles from './ProductList.module.css';
import { usePageContext } from '../../usePageContext.ts';

export const LIST_SHORTCUTS = [
  { key: 'j', action: 'next' },
  { key: 'k', action: 'previous' },
  { key: 'Enter', action: 'open' },
  { key: 'e', action: 'edit' },
  { key: 'a', action: 'adjust' },
  { key: 'x', action: 'select' },
  { key: '/', action: 'search' },
  { key: '?', action: 'help' },
  { key: 'Esc', action: 'close' },
] as const;

export const ShortcutsHelp = ({ onClose }: { onClose: () => void }) => {
  const { t } = usePageContext();
  return (
    <Dialog open title={t('shortcuts.title')} closeLabel={t('common.close')} onClose={onClose}>
      <dl className={styles['shortcuts']}>
        {LIST_SHORTCUTS.map(({ key, action }) => (
          <div key={key}>
            <dt>
              <kbd>{key}</kbd>
            </dt>
            <dd>{t(`shortcuts.${action}`)}</dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
};
